import { render, staticRenderFns } from "./ReportesInforme.vue?vue&type=template&id=1c4ff9cb&scoped=true&"
import script from "./ReportesInforme.vue?vue&type=script&lang=js&"
export * from "./ReportesInforme.vue?vue&type=script&lang=js&"
import style0 from "./ReportesInforme.vue?vue&type=style&index=0&id=1c4ff9cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4ff9cb",
  null
  
)

export default component.exports